export default "__VITE_ASSET__DK5ShYxt__"